import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@reach/accordion";
import "@reach/accordion/styles.css";
import styles from "./DeliveryStatus.module.scss";

export function DeliveryStatus({ statusList, type = "correios" }) {
  if (!Array.isArray(statusList)) return null;

  return (
    <div className="ordered-detail">
      <Accordion collapsible>
        <AccordionItem>
          <h6>
            <AccordionButton>
              Status da entrega <i className={styles.arrow}></i>
            </AccordionButton>
          </h6>
          <AccordionPanel>
            {(type === "correios" || type === "jadlog") && statusList.map(renderMailStatus)}
            {type === "motoboy" && statusList.map(renderMotoboyStatus)}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

function renderMailStatus(
  { status = "", data = "", origem = "", destino = "" , local = ""},
  index
) {
  return (
    <article key={index} className={styles["mail-order"]}>
      <h1>{status}</h1>
      {local ? (
         <p>{local}</p>
      ): (
        <>
        <p>{origem}</p>
        <p>{destino}</p>
        </>
      )}
      <p>{data}</p>
    </article>
  );
}

function renderMotoboyStatus({ status = "", data = "" }, index) {
  return (
    <article key={index} className={styles["motoboy-order"]}>
      <h1>{status}</h1>
      <p>{data}</p>
    </article>
  );
}
